export interface FeatureRuleItem {
  holdingIds?: string[];
}

export type FeatureRule = true | false | FeatureRuleItem[];

export type FeatureName =
  | 'presence.scheduling'
  | 'traceability.health-report'
  | 'reports.onepage_report'
  | 'reports.looker_dashboard'
  | 'section.labs'
  | 'section.reproductive'
  | 'help.show-button-header'
  | 'help.show-tooltip'
  | 'filter.nutrition_type'
  | 'target_new'
  | 'blocking_rules'
  | 's4farm_link'
  | 'PAYMENT'
  | 'USAGE_CONTROL'
  | 'TECHNICAL_SUPPORT'
  | 'PLANNING'
  | 'CORP_BASIC';

export interface FeatureContext {
  holdingId: string;
}

export function isFeatureEnabled(rule: FeatureRule | undefined, ctx?: FeatureContext): boolean {
  if (rule === undefined) return false;
  if (rule === true) return true;
  if (rule === false) return false;
  if (!ctx) return false;
  return rule.some((item) => item.holdingIds?.includes(ctx.holdingId));
}
